import React, { } from 'react';
import PropTypes from 'prop-types';
import CaseItemLink from './CaseItemLink';
import List from '@material-ui/core/List';
import { withStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import Grid from '@material-ui/core/Grid';
import { withRouter } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { connect } from 'react-redux';

const styles = theme => ({
    root: {

    },
  });

class CaseItemLinkList extends React.Component {

    state = {
        claimantFilter: ''
    }

    render() {
        const { classes, caseItems, context, history, match } = this.props;
        const { claimantFilter } = this.state;

        console.log('CaseItemLinkList caseItems: ', caseItems);
        if (caseItems == undefined) {
            return (
                <div className={classes.divStyle}>

                </div>
            );
        }
        else if (caseItems.length == 0) {
            if (localStorage.getItem('typeOfAccount') == 'arbitrator') {
                return (
                    <div className={classes.divStyle}>
                        <h4 className={classes.paper}> {context.t('There is no case in this account.')} </h4>
                    </div>
                );
            }
            else if (localStorage.getItem('typeOfAccount') == 'admin') {
                return (
                    <div className={classes.divStyle}>
                        <h4 className={classes.paper}> {context.t('There is no case in this account.')} </h4>
                    </div>
                );
            }
            else {
                return (
                    <div className={classes.divStyle}>
                        <h4 className={classes.paper}> {context.t('There is no case in this account.')} </h4>
                    </div>
                );
            }
        }
        else {

            const skipToken = localStorage.getItem('skipToken');
            const uniqueId = localStorage.getItem('uniqueId') || localStorage.getItem('skipUniqueId');
            const hasSkipCredentials = !!skipToken && !!uniqueId;

            if (caseItems.length == 1 && !hasSkipCredentials) {
                history.push(`${match.path}/${caseItems[0].caseId}`);
            }

            const normalizeClaimantGroup = (name) => {
                const trimmedName = name.trim();
                const normalizedName = trimmedName.toLowerCase().replace(/\s+/g, ' ');
                const kCashClaimants = {
                    'k cash limited': 'K CASH LIMITED',
                    'k cash express limited': 'K CASH EXPRESS LIMITED',
                    'k cash express limied (formerly known as konew financial express limited)': 'K CASH EXPRESS LIMITED (formerly known as KONEW FINANCIAL EXPRESS LIMITED)',
                    'k cash express limited (formerly known as konew financial express limited)': 'K CASH EXPRESS LIMITED (formerly known as KONEW FINANCIAL EXPRESS LIMITED)'
                };
                if (kCashClaimants[normalizedName]) {
                    return kCashClaimants[normalizedName];
                }
                if (normalizedName.includes('hong kong finance')) {
                    return 'Hong Kong Finance';
                }
                return trimmedName;
            };

            const filteredItems = claimantFilter === ''
                ? caseItems
                : caseItems.filter(item =>
                    item.claimantName && normalizeClaimantGroup(item.claimantName) === claimantFilter
                  );

            // Build claimant names with case counts, sorted by count descending
            const claimantCountMap = {};
            caseItems.forEach(item => {
                if (item.claimantName && item.claimantName.trim() !== '') {
                    const groupName = normalizeClaimantGroup(item.claimantName);
                    claimantCountMap[groupName] = (claimantCountMap[groupName] || 0) + 1;
                }
            });
            const claimantCollator = new Intl.Collator('en', {
                sensitivity: 'base',
                numeric: true
            });
            const claimantEntries = Object.entries(claimantCountMap).sort(([aName], [bName]) =>
                claimantCollator.compare(aName, bName)
            );

            return (
                <div className={classes.root}>
                    <div style={{padding: '16px 16px 8px 16px'}}>
                        <TextField
                            select
                            label="View by Claimant"
                            variant="outlined"
                            size="small"
                            value={claimantFilter}
                            onChange={(e) => this.setState({ claimantFilter: e.target.value })}
                            style={{width: '300px'}}
                        >
                            <MenuItem value="">
                                All ({caseItems.length})
                            </MenuItem>
                            {claimantEntries.map(([name, count]) => (
                                <MenuItem key={name} value={name}>
                                    {name} ({count})
                                </MenuItem>
                            ))}
                        </TextField>
                    </div>
                    <Grid container direction="row" alignItems="center" >
                        {
                            filteredItems.sort((a, b) => b.caseId - a.caseId).map((title, index) => (
                                <React.Fragment key={index}>
                                    <CaseItemLink primary={title} />
                                </React.Fragment>
                            ))
                        }
                    </Grid>
                </div>
            );
        }
    }
}

CaseItemLinkList.contextTypes = {
  t: PropTypes.func
}
export default withStyles(styles)(withRouter(CaseItemLinkList));